import { CircularProgress, Typography } from "@mui/material";
import { useState } from "react";
import { getPrediction } from "../../api/raman-api";
import Prediction from "./Prediction";
import SpectrumPlot from "./SpectrumPlot";
import Upload from "./Upload";
import XaiPlot from "./XaiPlot";

export default function RamanAnalysis() {
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);

    const onUploadClick = async (file) => {
        setResults(null);
        setLoading(true);
        setResults(await getPrediction(file));
        setLoading(false);
    };

    return (
        <div id="raman_net" className="RamanAnalysis">
            <div className="Container">
                <Typography variant="h2" className="SectionHeader">
                    ANALYZE <b>RAMAN</b> SPECTRUM
                </Typography>
                <br></br>
                <Upload onUploadClick={onUploadClick} />
                {loading && <CircularProgress />}
                {results && (
                    <div className="PredictionPlots">
                        <br></br>
                        <Typography variant="h4">
                            ANALYSIS <b>RESULTS</b>
                        </Typography>
                        <Prediction prediction={results.prediction} />
                        <SpectrumPlot
                            x={results.ramanShift}
                            y1={results.rawSignal}
                            y2={results.preprocessedSignal}
                        />
                        <XaiPlot
                            x={results.ramanShift}
                            y={results.preprocessedSignal}
                            c1={results.firstSignificant}
                            c2={results.secondSignificant}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
